import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type SchoolYear from "@shared/models/school-year"
import type Rpc from "cc-frontend/services/rpc"
import { task } from "ember-concurrency"
import { filter, includes, isNil, map } from "lodash-es"

export default class AdminHolidayNewComponent extends Component {
  @service("ember-store") store
  @service rpc!: Rpc
  @service router

  @tracked title: string | null = null
  @tracked startDate: string | null = null
  @tracked _endDate: string | null = null
  @tracked _isOff: boolean = false
  @tracked selectedSchoolYearIds: Array<string> = []
  @tracked schoolYears: Array<SchoolYear> = []

  get isOff(): boolean {
    return this._isOff
  }

  set isOff(_value) {
    this._isOff = !this._isOff
  }

  get endDate() {
    // Check that it's never before the start date
    // @ts-ignore I check this in the first condition
    if (isNil(this._endDate) || this._endDate < this.startDate) {
      return this.startDate
    } else {
      return this._endDate
    }
  }

  set endDate(value) {
    this._endDate = value
  }

  fetchSchoolYears = task({ keepLatest: true }, async () => {
    let records = await this.rpc.execute("ADMIN_SCHOOL_YEAR_INDEX")
    this.schoolYears = records.data
  })

  get selectedSchoolYears() {
    return filter(this.schoolYears, (schoolYear) =>
      includes(this.selectedSchoolYearIds, schoolYear.id)
    )
  }

  @action
  selectSchoolYear(array: Array<SchoolYear>) {
    this.selectedSchoolYearIds = map(array, "id")
  }

  createHoliday = task(async () => {
    if (this.title === null || this.startDate === null || this.endDate === null) {
      console.error("You need all the fields filled out")
      return
    }

    let { responseOk, result } = await this.rpc.holiday_admin_create({
      title: this.title || "",
      startDate: this.startDate,
      endDate: this.endDate,
      schoolYearIds: this.selectedSchoolYearIds,
      isOff: this.isOff,
    })

    if (responseOk === false) {
      console.error(result)
    } else {
      this.router.transitionTo("admin.holidays.show", (result as any).id)
    }
  })
}
